import styles from './welcome.module.scss'
import main from 'assets/images/main.png'

const Welcome = () => {
  return (
    <section className={styles.welcome}>
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img src={main} />
      <h2 style={{ color: '#812808' }}>뜻깊은 자리에 소중한 분들을 초대합니다</h2>
      <p>
        두 사람이 만든 인연이
        <br />
        하나의 매듭으로 새로운 길이 되어
        <br />
        하나뿐인 보금자리를 이루려 합니다.
        <br />
        그동안 변함없는 마음으로 아껴주신
        <br />
        마음 그대로 기쁨 가득한 날 오셔서
        <br />
        축복해 주시면 감사하겠습니다.
      </p>
      <div className={styles.host}>
        <div>
          <div>
            <span>임청희 · 김영순</span> 의 장남
          </div>
          <span>율</span>
        </div>
        <div>
          <div>
            <span>주철민 · 옥은숙</span> 의 장녀
          </div>
          <span>진희</span>
        </div>
      </div>
    </section>
  )
}

export default Welcome
